//Master Data: columns of the ESG council content list
const masterTableFields = [
    {title: "Level",
        class_name: 'w-110p',
        field: {name: "level"},
        fetch_key: "level"
    },
    {title: "Council",
        class_name: 'w-200p',
        field: {name: "council"},
        fetch_key: "council"
    },
    {title: "Individual Task",
        field: {name: "individual_task"},
        fetch_key: "individual_task"
    },
    {title: "Guidelines",
        field: {name: "discussion_guide"},
        fetch_key: "discussion_guide"
    },
    {title: "Learning",
        field: {name: "learn"},
        fetch_key: "learn"
    }
];

const levelOptions = [1, 2, 3].map(n => ({id: n, label: `Level ${n}`}));
const councilOptions = Array.from({length: 10}, (_, i) => ({id: i + 1, label: `Council ${i + 1}`}));
const yesNoOptions = [{id: 'yes', label: 'Yes'}, {id: 'no', label: 'No'}];

// Filter panel (button + floating panel, same concept as Filter Students)
const filterTableData = [
    {colMd: "3", label: "Level", type: "multi-select", name: "level"},
    {colMd: "3", label: "Council", type: "multi-select", name: "council_number"},
    {colMd: "6", label: "Search (task, guidelines, learning, title)", type: "text", name: "search"},
    {colMd: "3", label: "Has Individual Task", type: "select", name: "has_task"},
    {colMd: "3", label: "Has Guidelines", type: "select", name: "has_guidelines"},
    {colMd: "3", label: "Has Learning", type: "select", name: "has_learning"},
];

// Excel upload modal
const fieldValuesExcel = {
    level_id: '',
    excel_file: '',
    excel_file_data: ''
};

const fieldExcelContent = [
    {colMd: "3", label: "Level", required: true, type: "select", name: "level_id", placeholderData: ["Select Level"]},
    {colMd: "12", required: true, label: "Excel File", type: "file", name: "excel_file", file_type: ".xlsx, .xls", tagline: "Please populate the downloaded Template File (council number, individual task, guidelines and learning per row) and upload it. Keep row 1 (headings) and row 2 (instruction) as they are and fill the data from row 3."}
];

const fieldValidationExcel = {
    level_id: 'required||Level',
    excel_file: 'required'
};

const data = {
    masterTableFields,
    levelOptions,
    councilOptions,
    yesNoOptions,
    filterTableData,
    fieldValuesExcel,
    fieldExcelContent,
    fieldValidationExcel
};

export default data;
